import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import STRINGS from "../../utils/strings";
import CheckBox from "../fields/CheckBox";

export default function ServicesListitem({ data, handleClick, checked, hideCheckbox = false }) {
  const serviceCode = data?.serviceCode ?? null;
  const serviceName = data?.serviceName ?? null;
  const serviceDescription = data?.description ?? STRINGS.NO_SERVICE_DESCRIPTION;

  const handleOnClick = (checked) => {
    handleClick(checked, data);
  };

  return (
    <div>
      <CheckBox
        hideCheckbox={hideCheckbox}
        handleClick={handleOnClick}
        checked={checked}
        label={
          <div>
            <Typography
              className="text-[14px] font-semibold"
              sx={{
                color: hideCheckbox ? HNSColors.neutrals[400] : HNSColors.neutrals[100],
              }}
            >
              {serviceCode} | {serviceName}
              {hideCheckbox && (
                <span
                  style={{
                    marginLeft: 6,
                    color: HNSColors.neutrals[500],
                    fontWeight: 400,
                    fontSize: "10px",
                  }}
                >
                  (Added)
                </span>
              )}
            </Typography>

            <Typography className="text-[14px] font-normal" sx={{ color: HNSColors.neutrals[500] }}>
              {serviceDescription}
            </Typography>
          </div>
        }
      />
    </div>
  );
}
